import { Alert } from "@mui/material";
import { useEffect, useState } from "react";
import HttpService from "services/http.service";

const formatBRL = (valor) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(valor) || 0
  );

/**
 * Aviso quando o cliente (venda) ou o fornecedor (compra) tem contas não
 * resolvidas, ligadas a pedidos, acima do limite cadastrado
 * (limiteCredito no cliente, limiteCompras no fornecedor).
 */
export default function LimiteCreditoAlerta({
  tipo = "venda",
  pessoaId,
  pedidoId = null,
}) {
  const [credito, setCredito] = useState(null);

  useEffect(() => {
    const id = pessoaId?._id || pessoaId;
    if (!id) {
      setCredito(null);
      return;
    }

    let ativo = true;
    const recurso = tipo === "compra" ? "suppliers" : "customers";
    const query = pedidoId ? `?ignorarPedido=${pedidoId}` : "";

    HttpService.get(`/${recurso}/${id}/credito${query}`)
      .then((data) => ativo && setCredito(data))
      .catch(() => ativo && setCredito(null));

    return () => {
      ativo = false;
    };
  }, [tipo, pessoaId, pedidoId]);

  if (!credito?.excedido) return null;

  const numeros = (credito.pedidos || [])
    .map((p) => p.numPedido)
    .filter(Boolean)
    .join(", ");

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <b>Limite {tipo === "compra" ? "de compras" : "de crédito"} excedido:</b>{" "}
      {credito.nome} tem {formatBRL(credito.emAberto)} em contas não resolvidas
      {numeros ? ` (pedidos ${numeros})` : ""}, acima do limite de{" "}
      {formatBRL(credito.limite)}.
    </Alert>
  );
}
